import { Link } from 'react-router-dom';
import type { SpecialTopic } from '@/types/movie';
import { getMoviesByIds } from '@/data/catalog';

interface SpecialShowcaseProps {
  topics: SpecialTopic[];
}

export default function SpecialShowcase({ topics }: SpecialShowcaseProps) {
  if (topics.length === 0) return null;

  return (
    <div className="grid grid-cols-1 gap-3 md:grid-cols-2 md:gap-4">
      <Link
        to={`/special/${topics[0].id}`}
        className="group relative aspect-[16/11] w-full cursor-pointer overflow-hidden rounded-lg bg-primary-900 md:row-span-2 md:aspect-auto md:min-h-[420px]"
      >
        <img
          src={topics[0].cover}
          alt={`${topics[0].title}专题封面`}
          title={`${topics[0].title} 影视专题合集`}
          className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-primary-950 via-primary-950/40 to-transparent" />
        <div className="absolute inset-x-0 bottom-0 p-5 md:p-7">
          <span className="inline-flex items-center gap-1 rounded-md bg-accent-500 px-2 py-0.5 text-[11px] font-medium text-background-50">
            {topics[0].accentLabel}
          </span>
          <h3 className="mt-3 text-2xl font-bold text-background-50 md:text-3xl">{topics[0].title}</h3>
          <p className="mt-1.5 line-clamp-2 max-w-md text-xs leading-relaxed text-background-200/85 md:text-sm">
            {topics[0].subtitle} · 共 {getMoviesByIds(topics[0].movieIds).length} 部作品
          </p>
        </div>
      </Link>

      <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 md:gap-4">
        {topics.slice(1, 5).map((topic) => (
          <Link
            key={topic.id}
            to={`/special/${topic.id}`}
            className="group relative aspect-[16/10] w-full cursor-pointer overflow-hidden rounded-lg bg-primary-900"
          >
            <img
              src={topic.cover}
              alt={`${topic.title}专题封面`}
              title={`${topic.title} 影视专题合集`}
              className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-primary-950/95 via-primary-950/30 to-transparent" />
            <div className="absolute inset-x-0 bottom-0 p-3.5">
              <p className="font-label text-[10px] uppercase tracking-[0.2em] text-accent-300">{topic.accentLabel}</p>
              <h3 className="mt-1 truncate text-base font-semibold text-background-50">{topic.title}</h3>
              <p className="mt-0.5 truncate text-[11px] text-background-200/75">{topic.subtitle.split(' · ')[0]}</p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}